// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-container {
    background-color: var(--darkGreen);
    height: 100vh;
}

.logo-container {
    border-bottom: 0.5px solid;
    border-color: var(--sideBarBorderBottom);
    padding: 36px 20px 14px 20px;
    text-align: left;
}

.sidebar-menu-container {
    padding: 8px 20px;
    height: calc(100% - 88px);
    overflow: auto;
}

/* .sidebar-menu-container .menu-div .menu-name {
    color: var(--whiteLight);
} */
.sidebar-menu-container .menu-div a .sidebar-icon-box {
    min-width: 25px;
    margin-right: 10px;
}
.sidebar-menu-container .menu-div a .sidebar-icon-box svg {
    width: 100%;
}
.sidebar-menu-container .divider-color {
    border-color: var(--sideBarBorderBottom);
}

.sidebar-menu-container .menu-div a {
    padding: 12px 10px;
    border-radius: 10px;
    color: var(--whiteLight);
}

.sidebar-menu-container .menu-div a:hover,
.sidebar-menu-container .menu-div a.active {
    background-color: var(--primeryColor);
}

.sidebar-menu-container .menu-div a:hover svg path,
.sidebar-menu-container .menu-div a.active svg path{
    fill: var(--darkGreen);;
}
.sidebar-menu-container .menu-div a:hover .svg-stroke svg path,
.sidebar-menu-container .menu-div a.active .svg-stroke svg path{
    fill: unset;
    stroke: var(--darkGreen);
}
.sidebar-menu-container .menu-div a:hover,
.sidebar-menu-container .menu-div a.active{
    color: var(--darkGreen);

}
.sidebar-menu-container :has(>a.active) + .MuiDivider-root,
.sidebar-menu-container :has(>a.active) :has(+.MuiDivider-root){
    border-color: transparent;
}

`, "",{"version":3,"sources":["webpack://./src/Layouts/SideBar/SideBar.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,wCAAwC;IACxC,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;GAEG;AACH;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;;IAEI,sBAAsB;AAC1B;AACA;;IAEI,WAAW;IACX,wBAAwB;AAC5B;AACA;;IAEI,uBAAuB;;AAE3B;AACA;;IAEI,yBAAyB;AAC7B","sourcesContent":[".sidebar-container {\n    background-color: var(--darkGreen);\n    height: 100vh;\n}\n\n.logo-container {\n    border-bottom: 0.5px solid;\n    border-color: var(--sideBarBorderBottom);\n    padding: 36px 20px 14px 20px;\n    text-align: left;\n}\n\n.sidebar-menu-container {\n    padding: 8px 20px;\n    height: calc(100% - 88px);\n    overflow: auto;\n}\n\n/* .sidebar-menu-container .menu-div .menu-name {\n    color: var(--whiteLight);\n} */\n.sidebar-menu-container .menu-div a .sidebar-icon-box {\n    min-width: 25px;\n    margin-right: 10px;\n}\n.sidebar-menu-container .menu-div a .sidebar-icon-box svg {\n    width: 100%;\n}\n.sidebar-menu-container .divider-color {\n    border-color: var(--sideBarBorderBottom);\n}\n\n.sidebar-menu-container .menu-div a {\n    padding: 12px 10px;\n    border-radius: 10px;\n    color: var(--whiteLight);\n}\n\n.sidebar-menu-container .menu-div a:hover,\n.sidebar-menu-container .menu-div a.active {\n    background-color: var(--primeryColor);\n}\n\n.sidebar-menu-container .menu-div a:hover svg path,\n.sidebar-menu-container .menu-div a.active svg path{\n    fill: var(--darkGreen);;\n}\n.sidebar-menu-container .menu-div a:hover .svg-stroke svg path,\n.sidebar-menu-container .menu-div a.active .svg-stroke svg path{\n    fill: unset;\n    stroke: var(--darkGreen);\n}\n.sidebar-menu-container .menu-div a:hover,\n.sidebar-menu-container .menu-div a.active{\n    color: var(--darkGreen);\n\n}\n.sidebar-menu-container :has(>a.active) + .MuiDivider-root,\n.sidebar-menu-container :has(>a.active) :has(+.MuiDivider-root){\n    border-color: transparent;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
